import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Glossary,
  GlossaryHeader,
  GlossaryBody,
  GlossaryRow,
  GlossaryConcept,
  GlossaryDescription,
  QuizInfo,
  ResultInfo,
} from '../../NodeContentPreview/styles';
import { ViewSection } from '../styles';

const CorrelationContentTeacherPanel = ({ report, data }) => {
  const [selectedTerms, setSelectedTerms] = useState({});
  const [concepts, setConcepts] = useState([]);
  const [descriptions, setDescriptions] = useState([]);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [corrected, setCorrected] = useState(false);

  const conceptCount = concepts?.length || 0;

  const getAnswers = (newConcepts) => {
    const answers = report?.CorrelationAnswers;
    const getAnswerId = (conceptId) =>
      (answers || []).find((answer) => answer.correlation_concept_id === conceptId)?.correlation_description_id;
    return newConcepts.reduce((acc, curr) => ((acc[curr.id] = getAnswerId(curr.id)), acc), {});
  };

  useEffect(() => {
    const newConcepts = data?.CorrelationList?.Concepts || [];
    setConcepts(newConcepts);
    setSelectedTerms(getAnswers(newConcepts));
    const newDescriptions = newConcepts.map((concept) => ({
      id: concept.Description.id,
      body: concept.Description.body,
    }));
    setDescriptions(newDescriptions);
  }, []);

  useEffect(() => {
    if (conceptCount && report.state === 'accepted') {
      let correct = 0;
      concepts.forEach((concept) => {
        if (selectedTerms[concept.id] === concept.Description.id) {
          correct++;
        }
      });
      setCorrectAnswers(correct);
      setCorrected(true);
    }
  }, [concepts]);

  return (
    <>
      <ViewSection>
        <Glossary>
          <GlossaryHeader>
            <GlossaryConcept>{i18n.__('correlation_term')}</GlossaryConcept>
            <GlossaryDescription>{i18n.__('correlation_description')}</GlossaryDescription>
          </GlossaryHeader>
          <GlossaryBody>
            {concepts.map((concept, index) => {
              const { id, body, Description } = concept;
              const term = descriptions.find((term) => term.id === selectedTerms[id]);
              const className = selectedTerms[id] === Description.id ? 'correct' : 'error';
              return (
                <GlossaryRow key={id} even={index % 2}>
                  <GlossaryConcept dangerouslySetInnerHTML={{ __html: body }} />
                  <GlossaryDescription
                    dangerouslySetInnerHTML={{ __html: term ? term.body : i18n.__('correlation_no_desc_chosen') }}
                    className={corrected ? className : ''}
                  />
                </GlossaryRow>
              );
            })}
          </GlossaryBody>
        </Glossary>
        {corrected && <ResultInfo>{i18n.__('quiz_correcting_result', correctAnswers, conceptCount)}</ResultInfo>}
        <QuizInfo>{i18n.__(data.redoable ? 'correlation_redoable_desc' : 'correlation_not_redoable_desc')}</QuizInfo>
      </ViewSection>
    </>
  );
};

export default CorrelationContentTeacherPanel;

CorrelationContentTeacherPanel.propTypes = {
  data: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
};
